import BaseComponent from '../../../js/base-component';
import { Loader } from "@googlemaps/js-api-loader";

class EventInfo extends BaseComponent {
    constructor(element) {
        super(element);

        const apiKey = "AIzaSyBQ_aCybg5OOLgDeSGbDDptzH2hQ_vTfgA"; // Seeger DEV -- AIzaSyDIpv2RliUBlrAy3lCXmn0aKsR70RPKAac
        this.loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
        });

        this.eventInfoSelect = this.element.querySelector('#event-info-select');
        this.consent = false;

        window.addEventListener('CookiebotOnAccept', (e) => {
            if (Cookiebot.consent.preferences) {
                this.consent = Cookiebot.consent.preferences;

                if ( this.element.querySelector('.u-address__map') ) {
                    this.loadMap( this.element.querySelector('.u-address__map') );
                }
            }
        }, false);

        if (this.eventInfoSelect) {
            this.eventInfoSelect.addEventListener('change', (event) => {
                if (!event.target.value) return;

                const address = getAddress(event.target.value);
                const topTemplate = getEventTemplate('Top');

                updateAddress('.u-address__container-top', render(topTemplate, {
                    placeVisibility:        address.place ? '' : 'style="display:none;"',
                    place:                  address.place,
                    streetVisibility:       address.street.street && !address.street.href ? '': 'style="display:none;"',
                    street:                 address.street.street,
                    streetHrefVisibility:   address.street.href ? '': 'style="display:none;"',
                    streetHref:             address.street.href,
                    cityVisibility:         address.city ? '' : 'style="display:none;"',
                    city:                   address.city,
                    bookingVisibility:      address.booking ? '' : 'style="display:none;"',
                    booking:                address.booking
                }));

                const bottomTemplate = getEventTemplate('Bottom');

                if (!address.phone) {
                    address.phone = {
                        tel: '',
                        label: '',
                        text: '',
                    }
                }

                if (!address.eventdate) {
                    address.eventdate = {
                        title: '',
                        date: ''
                    }
                }

                address.phone = address.phone || {};

                updateAddress('.u-address__container-bottom', render(bottomTemplate, {
                    phoneVisibility: address.phone.tel ? '' : 'style="display:none;"',
                    phoneLabel: address.phone.label,
                    phoneTel: address.phone.tel,
                    phoneText: address.phone.text,
                    eventdateVisibility: address.eventdate.date ? '' : 'style="display:none;"',
                    eventdateTitle: address.eventdate.title,
                    eventdateDate: address.eventdate.date,
                    hintsVisibility: address.hints ? '' : 'style="display:none;"',
                    hints: address.hints || '',
                    mapVisibility: address.map.id && address.map.latitude && address.map.longitude ? '' : 'style="display:none;"',
                    mapId: address.map.id,
                    mapLatitude: address.map.latitude,
                    mapLongitude: address.map.longitude,
                    journeyVisibility: address.journey ? '' : 'style="display:none;"',
                    journey: address.journey,
                    consent: this.consent ? '' : 'not-loaded',
                }));

                // loadMap
                if ( this.consent ) {
                    this.loadMap( this.element.querySelector('.u-address__map') );
                }
            }, false);
        }

        let dates = document.querySelector('.u-event-info .u-address__dates') || '',
            addressData = false;

        if (dates) {
            dates.addEventListener('click', function() {
                dates.classList.toggle('is--active');
            });
        }

        /**
         * init functionality
         */
        const initEventInfo = function() {
            try {
                addressData = JSON.parse(document.getElementById('addressIds').innerHTML);
            } catch (e) {
                addressData = false;
            }
        };

        /**
         * get the template from the dom element
         * @param position
         * @returns {string}
         */
        const getEventTemplate = function(position) {
            return document.getElementById('addressTemplate' + position).innerHTML;
        }

        /**
         * get address data from json
         * @param id
         * @returns {*}
         */
        const getAddress = function(id) {
            return addressData[id];
        }

        /**
         * update whole address
         * @param selector
         * @param content
         */
        const updateAddress = (selector, content = '') => {
            document.querySelector(selector).innerHTML = content;
        }

        /**
         * render the template and variables
         * @param template
         * @param data
         * @returns {*}
         */
        const render = (template, data) => {
            return template.replace(/\$\{(\w+)\}/g, (_, name) => data[name] || "");
        }

        initEventInfo();
    }

    loadMap(container) {

        if (container) {
            const lat = Number(container.dataset.latitude);
            const lng = Number(container.dataset.longitude);

            container.classList.remove('not-loaded');

            this.loader.load().then(() => {
                let map = new google.maps.Map(container, {
                    center: { lat: lat, lng: lng },
                    fullscreenControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    zoomControl: false,
                    zoom: 14,
                });

                new google.maps.Marker({
                    position: { lat: lat, lng: lng },
                    map
                });
            });
        }
    }
}

export default {
    name: 'EventInfo',
    definition: EventInfo
};
